import DatePicker from "react-multi-date-picker";
import persian_fa from "react-date-object/locales/persian_fa";
import InputIcon from "react-multi-date-picker/components/input_icon";
import persian from "react-date-object/calendars/persian";
import "react-multi-date-picker/styles/colors/red.css";
import { AiOutlineArrowLeft } from "react-icons/ai";
interface PropType {
  title?: string;
  handleChange?: any;
  StartDateValues?: any;
  EndDateValues?: any;
  error?: any;
  important?: boolean;
  WrapperClassName?: string;
  readOnly?: boolean;
  StartDateName: string;
  EndDateName: string;
}

const TimeCalender = ({
  title,
  StartDateValues,
  EndDateValues,
  handleChange,
  error,
  important,
  WrapperClassName,
  StartDateName,
  EndDateName,
  readOnly,
}: PropType) => {
  return (
    <div className={`flex flex-col ${WrapperClassName}`}>
      <div
        className={`relative border flex-between-center ${
          error ? "border-red" : "border-darkBorder"
        } rounded-lg w-full ${readOnly && "opacity-40"}`}
      >
        <div className={`autocompleteLabel  ${error && "text-red"} z-10 -top-4`}>
          {title}{" "}
          <span className="text-tomato font-extrabold text-lg h-4">{important ? "*" : " "}</span>
        </div>
        <DatePicker
          disabled={readOnly}
          className="red z-0"
          calendar={persian}
          name={StartDateName}
          value={`${
            StartDateValues?.year + "/" + StartDateValues?.month + "/" + StartDateValues?.day
          }`}
          locale={persian_fa}
          format={"YYYY/MM/DD"}
          calendarPosition="bottom-right"
          onChange={(date: any) => {
            handleChange(StartDateName, {
              day: Number(date.day),
              month: Number(date.month),
              year: Number(date.year),
            });
          }}
        />
        <AiOutlineArrowLeft size={30} />
        <DatePicker
          disabled={readOnly}
          className="red z-0"
          calendar={persian}
          name={EndDateName}
          value={`${EndDateValues?.year + "/" + EndDateValues?.month + "/" + EndDateValues?.day}`}
          locale={persian_fa}
          format={"YYYY/MM/DD"}
          calendarPosition="bottom-right"
          onChange={(date: any) => {
            handleChange(EndDateName, {
              day: Number(date.day),
              month: Number(date.month),
              year: Number(date.year),
            });
          }}
          render={<InputIcon />}
        />
      </div>
      <p className="text-red text-xs pr-3 h-4 mt-1">{error}</p>
    </div>
  );
};

TimeCalender.defaultProps = {
  WrapperClassName: "w-96",
};

export default TimeCalender;
